import { FieldType } from 'controls/queryBuilder/ruleDefinition';

import { isListOperator } from './isListOperator';

// a multiselect takes a text only for LIKE
export function isListValue(type: FieldType, operator: string) {
	if (type == FieldType.MultiSelect) {
		return operator != 'like';
	}

	const single = [FieldType.Select, FieldType.Boolean, FieldType.Date, FieldType.Number];
	return !single.includes(type) && isListOperator(operator);
}
